import React from "react";
import "@/App.css";
import { Toaster } from "@/components/ui/sonner";
import { useReveal } from "@/lib/useReveal";

import Navbar from "@/components/Navbar";
import Hero from "@/components/Hero";
import AboutHH from "@/components/AboutHH";
import ProyectosDisponibles from "@/components/ProyectosDisponibles";
import AriakeShowcase from "@/components/AriakeShowcase";
import Amenities from "@/components/Amenities";
import Tipologias from "@/components/Tipologias";
import Ubicacion from "@/components/Ubicacion";
import Historial from "@/components/Historial";
import ContactForm from "@/components/ContactForm";
import Footer from "@/components/Footer";
import FloatingWhatsApp from "@/components/FloatingWhatsApp";

function App() {
  useReveal();
  return (
    <div className="App bg-[hsl(var(--hh-bone))]">
      <Navbar />
      <main>
        <Hero />
        <AboutHH />
        <ProyectosDisponibles />
        <AriakeShowcase />
        <Tipologias />
        <Amenities />
        <Ubicacion />
        <Historial />
        <ContactForm />
      </main>
      <Footer />
      <FloatingWhatsApp />
      <Toaster
        position="top-center"
        toastOptions={{
          style: {
            background: "hsl(0 0% 6%)",
            color: "hsl(40 22% 96%)",
            border: "1px solid hsl(0 0% 18%)",
            borderRadius: "2px",
            fontFamily: "Manrope, sans-serif",
          },
        }}
      />
    </div>
  );
}

export default App;
